export default __webpack_public_path__ + "076cb6b076cf7ee164ec159a33be187b.png";